import React from "react";
import _isEmpty from "lodash/isEmpty";
import PropTypes from "prop-types";
import { CustomFields as InvenioCustomFields } from "react-invenio-forms";
/* eslint-disable react/prop-types */

export const CustomFields = ({ record, config, resourceType }) => {
  if (_isEmpty(config)) return null;

  return (
    <InvenioCustomFields
      key={resourceType} // we need to recreate this, its state doesn't update for some reason
      config={config}
      record={record}
      templateLoaders={[
        (widget) => import(`../../fields`),
        (widget) => import(`@templates/custom_fields/${widget}.js`),
        (widget) => import(`@js/invenio_rdm_records/src/deposit/customFields`),
        (widget) => import(`react-invenio-forms`),
      ]}
      fieldPathPrefix="custom_fields"
    />
  );
};

CustomFields.propsTypes = {
  record: PropTypes.object.isRequired,
  config: PropTypes.arrayOf(
    PropTypes.shape({
      section: PropTypes.string.isRequired,
      displaySection: PropTypes.bool,
      fields: PropTypes.arrayOf(
        PropTypes.shape({
          field: PropTypes.string.isRequired,
          ui_widget: PropTypes.string.isRequired,
          props: PropTypes.object,
        })
      ),
    })
  ).isRequired,
  resourceType: PropTypes.string,
};

CustomFields.defaultProps = {};
